module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0076.jpg?v=6009d0b8";